module.exports = __webpack_public_path__ + "img/lite-small-dark.46441b56.svg";